import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 28px;

  .single-select-hint {
    font-size: 11px;
    color: #999;
    margin-left: 8px;
    font-style: italic;
  }

  .ads {
    margin: 0 auto;
    max-width: 900px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 16px;
    margin-top: 4px;
  }
`;

export const GroupTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;

  b {
    font-weight: 700;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border: 1px solid
      ${({ theme, $active }) =>
        $active ? theme.colors.primary.main : theme.colors.grey.white};
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary.main};

      h4,
      svg {
        color: ${({ theme }) => theme.colors.primary.main};
      }
    }

    h4,
    svg {
      transition: all 0.3s ease;
      color: ${({ theme, $active }) =>
        $active ? theme.colors.primary.main : theme.colors.grey.white};
    }

    .badge {
      position: absolute;
      top: -5px;
      right: -5px;
      background: ${({ theme }) => theme.colors.primary.main};
      color: white;
      border-radius: 50%;
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    flex-direction: column;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const ActiveFiltersBadge = styled.div`
  padding: 0.75rem 1rem;
  background: #e3f2fd;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #2196f3;

  span {
    color: #1976d2;
    font-weight: 500;
  }

  button {
    background: transparent;
    border: none;
    color: #1976d2;
    cursor: pointer;
    text-decoration: underline;
    font-weight: 500;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const FiltersModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const FiltersOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;

export const FiltersContent = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.grey[900]};
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const FiltersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[800]};

  h3 {
    color: ${({ theme }) => theme.colors.grey.white};
  }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.grey[200]};
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.grey[800]};
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;

export const ClearFiltersButton = styled.button`
  width: calc(100% - 3rem);
  margin: 1rem 1.5rem;
  padding: 0.75rem;
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background: #cc0000;
    transform: translateY(-1px);
  }
`;

export const FiltersBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.grey[800]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.grey[600]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.grey[500]};
  }
`;

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 2rem;

  @media ${({ theme }) => theme.devices.mobile} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FiltersColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background: ${({ theme }) => theme.colors.grey[800]};

  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  > p {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey.white};
    font-size: 0.95rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'nowrap')};
`;

export const FilterButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 2px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.colors.primary.main : theme.colors.grey[700]};
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.primary.main : theme.colors.grey[800]};
  color: ${({ theme }) => theme.colors.grey.white};
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
  font-size: 0.875rem;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.main};
    background: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.primary.dark : theme.colors.grey[700]};
  }

  &:active {
    transform: scale(0.95);
  }

  p {
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  flex-direction: column;
  gap: 4px;

  p {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.grey.white};

    small {
      margin: 4px 0;
      color: ${({ theme }) => theme.colors.grey[500]};
    }
  }
`;

export const Filter = styled.div`
  width: 100%;
  display: flex;
  padding: 8px 0;
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Bubble = styled.label`
  width: 100%;
  display: flex;
  margin: 2px 0;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.grey[600]};
  color: ${({ $checked, theme }) =>
    $checked ? theme.colors.primary.main : theme.colors.grey.white};
  border: 1px solid
    ${({ $checked, theme }) =>
      $checked ? theme.colors.primary.main : theme.colors.grey[800]};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const SelectGender = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 8px;
  }

  button {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    position: relative;
    padding: 10px 32px;
    border: none;
    color: ${({ theme }) => theme.colors.grey.white};
    border-radius: 25px;
    z-index: 0;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 33%;
    }

    h4 {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 18px;
      }
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 25px;
      background: ${({ theme }) => theme.colors.gradient.fullX};
      opacity: 0.3;
      z-index: -2;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 25px;
      padding: 2px;
      background: ${({ theme }) => theme.colors.gradient.fullX};
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }

    &:hover {
      &::before {
        transition: 0.7s;
        opacity: 1;
      }
    }

    &:nth-last-of-type(${({ $select }) => $select}) {
      &::before {
        opacity: 1;
      }
    }

    &.active {
      &::before {
        opacity: 1;
      }
    }

    h2 {
      color: ${({ theme }) => theme.colors.grey.white};
      margin-bottom: -4px;
    }
  }
`;

export const GroupPlans = styled.div`
  width: 100%;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    margin-top: 12px;
    gap: 20px 8px;
  }
`;

export const NotHasMoreModel = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const Empty = styled.div`
  width: 100%;
  padding: 20px 0;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  img {
    width: 100%;
    max-width: 120px;
  }

  button {
    margin-top: 1rem;
    padding: 0.75rem 1.5rem;
    background: ${({ theme }) => theme.colors.primary.main};
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.primary.dark};
      transform: translateY(-2px);
    }
  }
`;

export const ValueFilterGroup = styled.div`
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.grey[800]};
  border-radius: 12px;
  margin-bottom: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.grey[700]};

  > p {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const ValueInputs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.grey[300]};
      font-weight: 500;
    }

    input {
      padding: 0.75rem 1rem;
      border-radius: 8px;
      background: ${({ theme }) => theme.colors.grey[900]};
      border: 1px solid ${({ theme }) => theme.colors.grey[700]};
      color: ${({ theme }) => theme.colors.grey.black};
      font-size: 0.95rem;
      transition: all 0.2s;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary.main};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary.main}20;
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.grey[500]};
      }
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    grid-template-columns: 1fr;
  }
`;
